/** Recheck server-owned identity across origins, tabs, and restored browser pages. */
export function observeSession(refresh: (signal: AbortSignal) => Promise<void>, interval = 5000): () => void {
  const controller = new AbortController();
  let pending = false;
  const check = async () => {
    if (pending || controller.signal.aborted) return;
    pending = true;
    try {
      await refresh(AbortSignal.any([controller.signal, AbortSignal.timeout(15000)]));
    } catch {
      // A network failure is not proof of logout. Retry on the next tick or focus.
    } finally {
      pending = false;
    }
  };
  const visible = () => { if (document.visibilityState === "visible") void check(); };
  const timer = window.setInterval(() => { void check(); }, interval);
  window.addEventListener("focus", check);
  window.addEventListener("pageshow", check);
  document.addEventListener("visibilitychange", visible);
  void check();
  return () => {
    controller.abort();
    window.clearInterval(timer);
    window.removeEventListener("focus", check);
    window.removeEventListener("pageshow", check);
    document.removeEventListener("visibilitychange", visible);
  };
}
